__turbopack_context__.v({
  "barScopeButton": "CumulativeDonations-module-scss-module__xSbqOa__barScopeButton",
  "barScopeToggle": "CumulativeDonations-module-scss-module__xSbqOa__barScopeToggle",
  "chartTypeButton": "CumulativeDonations-module-scss-module__xSbqOa__chartTypeButton",
  "chartTypeToggle": "CumulativeDonations-module-scss-module__xSbqOa__chartTypeToggle",
  "controls": "CumulativeDonations-module-scss-module__xSbqOa__controls",
  "graph": "CumulativeDonations-module-scss-module__xSbqOa__graph",
  "graphContainer": "CumulativeDonations-module-scss-module__xSbqOa__graphContainer",
  "innerGraph": "CumulativeDonations-module-scss-module__xSbqOa__innerGraph",
  "mobileBarScope": "CumulativeDonations-module-scss-module__xSbqOa__mobileBarScope",
  "mobileChartMeta": "CumulativeDonations-module-scss-module__xSbqOa__mobileChartMeta",
  "mobileChartMetaRight": "CumulativeDonations-module-scss-module__xSbqOa__mobileChartMetaRight",
  "rightControls": "CumulativeDonations-module-scss-module__xSbqOa__rightControls",
  "swipeHint": "CumulativeDonations-module-scss-module__xSbqOa__swipeHint",
  "yearRail": "CumulativeDonations-module-scss-module__xSbqOa__yearRail",
  "yearRailDragging": "CumulativeDonations-module-scss-module__xSbqOa__yearRailDragging",
  "yearRailHandle": "CumulativeDonations-module-scss-module__xSbqOa__yearRailHandle",
  "yearRailHandleGlyph": "CumulativeDonations-module-scss-module__xSbqOa__yearRailHandleGlyph",
  "yearRailHandleGrip": "CumulativeDonations-module-scss-module__xSbqOa__yearRailHandleGrip",
  "yearRailRange": "CumulativeDonations-module-scss-module__xSbqOa__yearRailRange",
  "yearRailYear": "CumulativeDonations-module-scss-module__xSbqOa__yearRailYear",
  "yearRailYearActive": "CumulativeDonations-module-scss-module__xSbqOa__yearRailYearActive",
});
